import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, watch } from 'vue';
import { Color } from 'chroma-js';
import { getContrastColor } from 'util/color-util';

export default /*#__PURE__*/_defineComponent({
  __name: 'contrast-text',
  props: {
    color: null,
    r: null,
    b: null,
    g: null
  },
  setup(__props: any) {

const props = __props as {
    color?: Color,
    r?: number,
    b?: number,
    g?: number
}



const textColor = computed(() => {
    let rgb : [number, number, number] = props.color ? props.color.rgb() : [props.r ?? 0, props.g ?? 0, props.b ?? 0];
    return getContrastColor(rgb[0], rgb[1], rgb[2])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle({ color: _unref(textColor) })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}
}

})